<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13wIl1h/image/cover.jpg?1718046516663" alt="This image is the cover for the book Show Game"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Show Game
      </h1>
      <p class="bookDescription body article font2">
        <b>A mysterious vigilante abducts powerful abusers and exposes them in a twisted “Show Game,” in this psychological thriller by the author of <i>The Preserve</i>.</b><br/><br/> The pandemic may be over, but the world is not safe for those who prey on the innocent. A vigilante known by the alias “Alex” knows what these transgressors have done. And taking them captive is only the first step toward vengeance. In order to be set free, they must first play the Show Game . . .<br/><br/> A predatory priest, a double-dealing politician, a fraudulent philanthropist—Alex has ways of making them confess, on camera, for all the world to witness. But the Show Game is building toward a darkly personal finale: exposing society’s most notorious and evil abuser.<br/><br/> As Alex gets closer to the main event, investigative reporter Owen Tanaka is determined to unmask the vigilante’s true identity and motive. But when a shocking revelation hits close to home, Owen must decide whether to stop a criminal mastermind’s devious scheme . . . or let the Show Game play its final round.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Anderson
      </h2>
      
      <p class="authorDescription body article"> Steve Anderson&#160;is the author of the Kaspar Brothers novels:&#160;<I>The Losing Role</I>,&#160;<I>Liberated</I>,&#160;<I>Lost Kin</I>, and <I>Lines of Deception</I>.&#160;<I>Under False Flags&#160;</I>is the prequel to his novel&#160;<I>The Preserve</I>. Anderson was a Fulbright Fellow in Germany and is a literary translator of bestselling German fiction as well as a freelance editor. He lives in Portland, Oregon. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c348e690